module.exports = __webpack_public_path__ + "img/header-logo-en.1132acf9.png";